import { Routes } from '@angular/router';
import { CONTAINER_ROUTE } from './routes';

export const routes: Routes = [
  CONTAINER_ROUTE
];
